/**
 * Convert any YouTube URL variant to a valid iframe-embed URL.
 *
 * YouTube blocks /watch?v=… inside iframes (X-Frame-Options: DENY).
 * Only /embed/VIDEO_ID URLs are allowed. Same rule applies to Vimeo
 * (needs player.vimeo.com/video/ID).
 *
 * Handles:
 *   https://www.youtube.com/watch?v=abc123      →  https://www.youtube.com/embed/abc123
 *   https://youtu.be/abc123                     →  https://www.youtube.com/embed/abc123
 *   https://www.youtube.com/embed/abc123        →  unchanged (already embed)
 *   https://youtube.com/shorts/abc123           →  https://www.youtube.com/embed/abc123
 *   https://vimeo.com/12345                     →  https://player.vimeo.com/video/12345
 *   Anything else                               →  returned as-is (assume already embed-ready)
 */
export const toEmbedUrl = (url) => {
    if (!url || typeof url !== 'string') return '';
    const raw = url.trim();
    if (!raw) return '';

    // youtu.be short link
    let m = raw.match(/youtu\.be\/([\w-]+)/i);
    if (m) return `https://www.youtube.com/embed/${m[1]}`;

    // youtube.com/watch?v=VIDEO_ID (with any extra params)
    m = raw.match(/youtube\.com\/watch\?[^#]*[?&]?v=([\w-]+)/i);
    if (m) return `https://www.youtube.com/embed/${m[1]}`;

    // youtube.com/shorts/VIDEO_ID
    m = raw.match(/youtube\.com\/shorts\/([\w-]+)/i);
    if (m) return `https://www.youtube.com/embed/${m[1]}`;

    // Vimeo bare number URL
    m = raw.match(/vimeo\.com\/(\d+)/i);
    if (m && !raw.includes('player.vimeo.com')) return `https://player.vimeo.com/video/${m[1]}`;

    // Already an embed URL or unrecognized — return as-is
    return raw;
};
